import GetOrCreateOneToOneConversationUseCase from '../../chats/use-cases/GetOrCreateOneToOneConversationUseCase';
import SendMessageUseCase from '../../chats/use-cases/SendMessageUseCase';

class SendMessageToSelectedUsersUseCase {
    /**
     * @param {ChatRepository} chatRepository
     */
    constructor(chatRepository) {
        this.getOrCreateConversation = new GetOrCreateOneToOneConversationUseCase(chatRepository);
        this.sendMessage = new SendMessageUseCase(chatRepository);
    }

    /**
     * Sends a message to a specific list of users.
     * @param {string} senderId
     * @param {string} senderName
     * @param {ChatUser[]} targetUsers
     * @param {string} messageText
     */
    async execute(senderId, senderName, targetUsers, messageText) {
        if (!senderId || !senderName || !messageText || !messageText.trim()) {
            throw new Error('Sender ID, sender name, and message text are required.');
        }
        const results = await Promise.allSettled(
            targetUsers.map(async (user) => {
                const conversation = await this.getOrCreateConversation.execute(
                    senderId, senderName, user.uid, user.name
                );
                await this.sendMessage.execute(conversation.id, senderId, senderName, messageText.trim(), 'text');
            })
        );
        const failed = results.filter(r => r.status === 'rejected');
        if (failed.length > 0) {
            console.error(`Failed to send to ${failed.length} user(s):`, failed.map(f => f.reason));
        }
    }
}

export default SendMessageToSelectedUsersUseCase;
